import React, {FC} from 'react';

//MUI
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

//GEOCOMPONENTS
import BaseMapList from '@geomatico/geocomponents/Map/BaseMapList';
import LayerSwitcher from '@geomatico/geocomponents/Map/LayerSwitcher';

//CLAS
import StepSlider from '../StepSlider';

//UTILS
import {useTranslation} from 'react-i18next';
import {MAP_DETAIL_STYLES, MAPSTYLES, PNOA_HISTORICO_ID, PRIVATE_LAYERS} from '@/config';
import {SxProps} from '@mui/system/styleFunctionSx/styleFunctionSx';

const layerSwitcherStyle = {
  '&.LayerSwitcher-root': {
    justifyContent: 'flex-start',
  }
};

const baseMapListSx: SxProps = {
  '&.LayerSwitcher-root': {
    justifyContent: 'flex-start',
    mt: 1
  },
};

export interface NavigationMenuProps {
  mapDetail: Array<string>,
  mapStyleId: string,
  PNOASelectedYear: number,
  overlayIds: Array<string>,
  onMapDetailChange: (detail: Array<string>) => void
  onPNOAYearChange: (value: number) => void,
  onOverlayChange: (value: Array<string>) => void,
  onStyleChange: (mapStyleId: string) => void,
}

const THUMBNAIL_MEASURE = 40;
const ITEM_WIDTH = 80;

const NavigationMenu: FC<NavigationMenuProps> = ({
  mapDetail,
  mapStyleId,
  PNOASelectedYear,
  overlayIds,
  onMapDetailChange,
  onOverlayChange,
  onPNOAYearChange,
  onStyleChange,
}) => {

  const {t} = useTranslation();

  return <>
    <Typography variant='overline' sx={{mt: 0}}>{t('baseMapStyle.title')}</Typography>
    <BaseMapList
      variant='list'
      styles={MAPSTYLES}
      selectedStyleId={mapStyleId}
      onStyleChange={onStyleChange}
      itemWidth={ITEM_WIDTH}
      thumbnailWidth={THUMBNAIL_MEASURE}
      thumbnailHeight={THUMBNAIL_MEASURE}
      sx={baseMapListSx}
    />
    {
      mapStyleId === PNOA_HISTORICO_ID ? <StepSlider PNOASelectedYear={PNOASelectedYear} onPNOAYearChange={onPNOAYearChange}/> : undefined
    }
    <Divider/>
    <Typography variant='overline' sx={{mt: 1.5}}>{t('conditions')}</Typography>
    <LayerSwitcher
      variant='list'
      layers={MAP_DETAIL_STYLES}
      selectedLayerIds={mapDetail}
      exclusive={false}
      allowEmptyValue={true}
      onLayerChange={onMapDetailChange}
      itemWidth={ITEM_WIDTH}
      thumbnailWidth={THUMBNAIL_MEASURE}
      thumbnailHeight={THUMBNAIL_MEASURE}
      sx={layerSwitcherStyle}
    />
    <Divider/>
    <Typography variant='overline' sx={{mt: 1.5}}>{t('layers')}</Typography>
    <LayerSwitcher
      variant='list'
      layers={PRIVATE_LAYERS}
      selectedLayerIds={overlayIds}
      exclusive={false}
      allowEmptyValue={true}
      onLayerChange={onOverlayChange}
      itemWidth={ITEM_WIDTH}
      thumbnailWidth={THUMBNAIL_MEASURE}
      thumbnailHeight={THUMBNAIL_MEASURE}
      sx={layerSwitcherStyle}
    />
  </>;
};

export default NavigationMenu;